"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signatureLineStyles = exports.signatureCanvasStyles = void 0;
const signatureCanvasStyles = (borderColor) => ({
    width: '100%',
    height: '8rem',
    border: `1px solid ${borderColor}`,
    borderRadius: 4,
    margin: '1rem 0',
});
exports.signatureCanvasStyles = signatureCanvasStyles;
const signatureLineStyles = (borderColor) => ({
    borderTop: `1px solid ${borderColor}`,
    width: '80%',
    bottom: '3rem',
    margin: 'auto',
    position: 'relative',
});
exports.signatureLineStyles = signatureLineStyles;
//# sourceMappingURL=SignatureInput.styles.js.map